import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)



export default new Vuex.Store({
  state: {
    step: 1,
    client: undefined,
    loading: false,
    sampleUrl: '',
    serverError: false,
    sampleWatching: false,
    customErrorText: [],
    programs: ['Базовая за 4 900 руб. в год', 'Комфорт за 11 900 руб. в год', 'Премиум за 20 900 руб. в год'],
    selectedProgram: ''
  },
  mutations: {
    setLoading(state, payload) {
      state.loading = payload
    },
    nextStep(state){
      state.step++
      document.getElementById('accepting-orders-form').scrollTo({top: 0, behavior:'smooth'})
    },
    prevStep(state){
      state.step--
    },
    throwError(state){
      state.serverError = true
      document.dispatchEvent(new Event('ym-error'))
    },
    cancelError(state){
      state.serverError = false
    },
    setClient(state, client){
      state.client = client
    },
    setSampleUrl(state, url){
      state.sampleUrl = url
    },
    setSelectedProgram(state, program){
      state.selectedProgram = program
    },
    setSelectedProgramByIndex(state, index){
      if (state.programs[index] !== undefined) 
        state.selectedProgram = state.programs[index]
      else
        console.error(`setSelectedProgramByIndex: программа с индексом ${index} отсутствует`)
    },
    customErrorText(state, customErrorText){
      state.customErrorText = customErrorText
    },
    watchSample(state){
      state.sampleWatching = true
      document.dispatchEvent(new Event('ym-obrazec_pdf'))
    },
    closeSample(state){
      state.sampleWatching = false
    }
  }
})
